import React, { useEffect,useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../hooks/hooks';
import { selectGlobalLogisticsCatalogQueryItems } from '../../../../redux/global-logistics/selector';
import { globalLogisticsCatalog } from '../../../../redux/global-logistics/action';
import PageLoader from '../../../../components/PageLoader';
import GlobalLogisticCatalogComponent from '../components/global-logistics-component.tsx/components/global-logistics-catalog-details.component';



const GlobalLogisticCatalogDetails = () => {   
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const globalLogisticsCatalogItems = useSelector(selectGlobalLogisticsCatalogQueryItems)
const [isQuery, setIsQuery] = useState<boolean>(false)
const [isLoading, setIsLoading] = useState<boolean>(true)

  const [
    selectedGlobalLogisticsCatalog,
    setSelectedGlobalLogisticsCatalog
  ] = useState<any>([])
 

  const fetchDbnpMappingById= ()=>{
     dispatch(globalLogisticsCatalog.query({url:`https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.2/logistics/transport/global-logistics-catalogs/fetch-detail`,entity:'globalLogisticsCatalog',jsonData:{
              "Context": {},
                   "Records": [
                       {
                        "ProviderId": Number(parmas?.id),
                        
                       }
     ]
           }})).then(()=>{
  setIsQuery(true)
})

  }

 
  useEffect(
    () => {
            if (parmas?.id > 0) {
                fetchDbnpMappingById()
                setIsLoading(false)
              }else {
                setIsLoading(false)
              }
    },
    []
  )
  useEffect(
    () => {
        
      if (isQuery) {
        setSelectedGlobalLogisticsCatalog(globalLogisticsCatalogItems?.result?.items)
      }
    },
    [isQuery]
  )
 


const back=()=>{
  navigate('/dbn/global-dbnp-registrations')
} 

    return (
    <>
     {isLoading ? <PageLoader /> : 
          <GlobalLogisticCatalogComponent 
          selectedGlobalLogisticsCatalog={selectedGlobalLogisticsCatalog}
           back={back}
          /> 
        } 
          </>
    )
    
    }
   
    export default GlobalLogisticCatalogDetails;